import { render, staticRenderFns } from "./OutsourcingBankListEdit.vue?vue&type=template&id=f5d985f8&scoped=true&"
import script from "./OutsourcingBankListEdit.vue?vue&type=script&lang=js&"
export * from "./OutsourcingBankListEdit.vue?vue&type=script&lang=js&"
import style0 from "./OutsourcingBankListEdit.vue?vue&type=style&index=0&id=f5d985f8&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f5d985f8",
  null
  
)

export default component.exports